import { createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("span", { class: "sr-only" }, "Use setting", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Switch = _resolveComponent("Switch")!

  return (_openBlock(), _createBlock(_component_Switch, {
    modelValue: _ctx.enabled,
    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.enabled) = $event)),
    class: _normalizeClass([_ctx.enabled ? 'bg-gray-900 bg-opacity-90' : 'bg-gray-900  bg-opacity-50', "relative inline-flex flex-shrink-0 w-8 h-4 transition-colors duration-200 ease-in-out border-2 border-transparent rounded-full cursor-pointer md:h-5 md:w-10 focus:outline-none focus-visible:ring-2 focus-visible:ring-white focus-visible:ring-opacity-75"]),
    "bind:checked": _ctx.checked,
    onChange: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('change', $event.target.checked)))
  }, {
    default: _withCtx(() => [
      _hoisted_1,
      _createElementVNode("span", {
        "aria-hidden": "true",
        class: _normalizeClass([_ctx.enabled ? 'translate-x-4 md:translate-x-5' : 'translate-x-0', "inline-block w-3 h-3 transition duration-200 ease-in-out transform bg-white rounded-full shadow-lg pointer-events-none md:h-4 md:w-4 ring-0"])
      }, null, 2)
    ]),
    _: 1
  }, 8, ["modelValue", "class", "bind:checked"]))
}